module.exports = __webpack_public_path__ + "fonts/Gotham-Book.6a185de4.woff2";